// extracted by mini-css-extract-plugin
export default {"main":"AIRubricMarkLine_main__VHIpi","header":"AIRubricMarkLine_header__ixxsk"};